
import React from 'react';
import Home from './home';
import Transform from './transform';
import Testimonials from './testimonials';
import Contact from './contact';
import Services from './services';
import Portfolio from './portfolio';

const AllPages = () => {
  return (
    <div className='font-Poppins'>
      <Home />
        <Transform />
        <Portfolio/>
        <Services />
        <Testimonials />
        <Contact/>
    </div>
  )
};

export default AllPages;
